import { Types } from '@core';
import { ViewportTypes } from '@core/enums';
import { REMOTE_VIEW_ID, SettingGroupID } from 'types';

const remoteMPR: Types.HangingProtocol.Protocol = {
	id: SettingGroupID.remoteMPR,
	name: 'Remote MPR',
	locked: true,
	icon: '',
	isPreset: true,
	createdDate: '2024-07-16T10:00:00.000Z',
	modifiedDate: '2024-07-16T10:00:00.000Z',
	availableTo: {},
	editableBy: {},
	protocolMatchingRules: [],
	displaySetSelectors: {
		isReconstructableDisplaySet: {
			seriesMatchingRules: [
				{
					weight: 1,
					attribute: 'isReconstructable',
					constraint: {
						equals: { value: true },
					},
					required: true,
				},
			],
		},
	},
	toolGroupIds: ['remoteRender3D'],
	stages: [
		{
			id: 'remote_mprPrimary_axial',
			name: 'Axial Primary',
			viewportStructure: {
				layoutType: 'grid',
				properties: {
					rows: 2,
					columns: 3,
					layoutOptions: [
						{ x: 0, y: 0, width: 2 / 3, height: 1 },
						{ x: 2 / 3, y: 1 / 2, width: 1 / 3, height: 1 / 2 },
						{ x: 2 / 3, y: 0, width: 1 / 3, height: 1 / 2 },
						{ x: 0, y: 0, width: 0, height: 0 },
					],
				},
			},
			viewports: [
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['AXIAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['CORONAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['SAGITTAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['3D'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
			],
		},
		{
			id: 'remote_mprPrimary_sagittal',
			name: 'Sagittal Primary',
			viewportStructure: {
				layoutType: 'grid',
				properties: {
					rows: 2,
					columns: 3,
					layoutOptions: [
						{ x: 0, y: 0, width: 2 / 3, height: 1 },
						{ x: 2 / 3, y: 1 / 2, width: 1 / 3, height: 1 / 2 },
						{ x: 2 / 3, y: 0, width: 1 / 3, height: 1 / 2 },
						{ x: 0, y: 0, width: 0, height: 0 },
					],
				},
			},
			viewports: [
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['SAGITTAL'], // Đưa Sagittal vào ô to
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['AXIAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['CORONAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['3D'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
			],
		},
		{
			id: 'remote_mprPrimary_coronal',
			name: 'Coronal Primary',
			viewportStructure: {
				layoutType: 'grid',
				properties: {
					rows: 2,
					columns: 3,
					layoutOptions: [
						{ x: 0, y: 0, width: 2 / 3, height: 1 },
						{ x: 2 / 3, y: 1 / 2, width: 1 / 3, height: 1 / 2 },
						{ x: 2 / 3, y: 0, width: 1 / 3, height: 1 / 2 },
						{ x: 0, y: 0, width: 0, height: 0 },
					],
				},
			},
			viewports: [
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['CORONAL'], // Đưa Coronal vào ô to
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['SAGITTAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['AXIAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['3D'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
			],
		},
		{
			id: 'axialOnly',
			name: 'Axial Only',
			viewportStructure: {
				layoutType: 'grid',
				properties: {
					rows: 1,
					columns: 1,
					layoutOptions: [
						{ x: 0, y: 0, width: 1, height: 1 }, // Axial chiếm full
						{ x: 0, y: 0, width: 0, height: 0 }, // View 3D ẩn
					],
				},
			},
			viewports: [
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['AXIAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['3D'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
			],
		},
		{
			id: 'remote_threeColumn_ASC',
			name: 'Three Column ASC',
			viewportStructure: {
				layoutType: 'grid',
				properties: {
					rows: 1,
					columns: 3,
					layoutOptions: [
						{ x: 0, y: 0, width: 1 / 3, height: 1 },
						{ x: 1 / 3, y: 0, width: 1 / 3, height: 1 },
						{ x: 2 / 3, y: 0, width: 1 / 3, height: 1 },
						{ x: 0, y: 0, width: 0, height: 0 },
					],
				},
			},
			viewports: [
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['AXIAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['SAGITTAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['CORONAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['3D'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
			],
		},
		{
			id: 'remote_threeColumn_SCA',
			name: 'Three Column SCA',
			viewportStructure: {
				layoutType: 'grid',
				properties: {
					rows: 1,
					columns: 3,
					layoutOptions: [
						{ x: 0, y: 0, width: 1 / 3, height: 1 },
						{ x: 1 / 3, y: 0, width: 1 / 3, height: 1 },
						{ x: 2 / 3, y: 0, width: 1 / 3, height: 1 },
						{ x: 0, y: 0, width: 0, height: 0 },
					],
				},
			},
			viewports: [
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['SAGITTAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['CORONAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['AXIAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['3D'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
			],
		},
		{
			id: 'remote_threeColumn_CAS',
			name: 'Three Column CAS',
			viewportStructure: {
				layoutType: 'grid',
				properties: {
					rows: 1,
					columns: 3,
					layoutOptions: [
						{ x: 0, y: 0, width: 1 / 3, height: 1 },
						{ x: 1 / 3, y: 0, width: 1 / 3, height: 1 },
						{ x: 2 / 3, y: 0, width: 1 / 3, height: 1 },
						{ x: 0, y: 0, width: 0, height: 0 },
					],
				},
			},
			viewports: [
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['CORONAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['AXIAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['SAGITTAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['3D'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
			],
		},
		{
			id: 'coronalOnly',
			name: 'Coronal Only',
			viewportStructure: {
				layoutType: 'grid',
				properties: {
					rows: 1,
					columns: 1,
					layoutOptions: [
						{ x: 0, y: 0, width: 1, height: 1 }, // Coronal chiếm full
						{ x: 0, y: 0, width: 0, height: 0 }, // View 3D ẩn
					],
				},
			},
			viewports: [
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['CORONAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['3D'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
			],
		},
		{
			id: 'sagittalOnly',
			name: 'Sagittal Only',
			viewportStructure: {
				layoutType: 'grid',
				properties: {
					rows: 1,
					columns: 1,
					layoutOptions: [
						{ x: 0, y: 0, width: 1, height: 1 }, // Sagittal chiếm full
						{ x: 0, y: 0, width: 0, height: 0 }, // View 3D ẩn
					],
				},
			},
			viewports: [
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['SAGITTAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['3D'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [{ id: 'isReconstructableDisplaySet' }],
				},
			],
		},
		{
			id: 'fourUp',
			name: 'fourUp',
			viewportStructure: {
				layoutType: 'grid',
				properties: {
					rows: 2,
					columns: 2,
					layoutOptions: [
						{
							x: 0,
							y: 0,
							width: 1 / 2,
							height: 1 / 2,
						},
						{
							x: 1 / 2,
							y: 0,
							width: 1 / 2,
							height: 1 / 2,
						},
						{
							x: 0,
							y: 1 / 2,
							width: 1 / 2,
							height: 1 / 2,
						},
						{
							x: 1 / 2,
							y: 1 / 2,
							width: 1 / 2,
							height: 1 / 2,
						},
					],
				},
			},
			viewports: [
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['3D'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [
						{
							id: 'isReconstructableDisplaySet',
						},
					],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['AXIAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [
						{
							id: 'isReconstructableDisplaySet',
						},
					],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['CORONAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [
						{
							id: 'isReconstructableDisplaySet',
						},
					],
				},
				{
					viewportOptions: {
						viewportId: REMOTE_VIEW_ID['SAGITTAL'],
						viewportType: ViewportTypes.REMOTE_RENDER,
						toolGroupId: '3d',
					},
					displaySets: [
						{
							id: 'isReconstructableDisplaySet',
						},
					],
				},
			],
		},
	],
	callbacks: {
		onProtocolExit: [
			{
				commandName: 'clientClearConnection',
			},
		],
		onProtocolEnter: [
			{
				commandName: 'switchButtonSection',
				commandOptions: {
					buttonSectionID: 'remoteMPR', // Có thể dùng chung hoặc tạo riêng cho MPR
				},
				context: 'DEFAULT',
			},
			{
				commandName: 'onEnterMpr3dProtocol',
				commandOptions: {
					remoteRenderMode: true,
				},
				context: 'CORNERSTONE',
			},
			{
				commandName: 'createNewConnection',
			},
		],
	},
};

export default remoteMPR;
